import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges } from '@angular/core';
//
import { TranslateService } from '@services';

export interface UnpublishImpactLine {
    labelKey: string;
    value: number;
}

/**
 * Advertencia previa a una acción que da de baja alumnos (eliminar un campamento o despublicar
 * un contenido de él). Muestra el conteo real calculado por el backend (simulación de solo
 * lectura) y exige escribir la palabra de confirmación antes de habilitar la acción.
 * El padre carga el impacto y pasa `loading` / `failed` / `lines`.
 */
@Component({
    selector: 'msc-unpublish-impact-warning',
    templateUrl: './unpublish-impact-warning.component.html',
    styleUrls: ['./unpublish-impact-warning.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnpublishImpactWarningComponent implements OnChanges {
    @Input() consequenceKey: string;
    @Input() confirmWordKey: string = 'organize.unpublish-warning.confirm-word';
    @Input() lines: UnpublishImpactLine[] = [];
    @Input() loading: boolean = false;
    @Input() failed: boolean = false;
    // Cambia en cada apertura del modal para limpiar lo escrito.
    @Input() resetToken: any;
    @Output() confirmedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public typed: string = '';

    constructor(private readonly translateService: TranslateService) { }

    ngOnChanges(changes: any): void {
        if (changes.resetToken) {
            this.typed = '';
            this.confirmedChange.emit(false);
        }
    }

    get confirmWord(): string {
        return this.translateService.instant(this.confirmWordKey);
    }

    onTyped(value: string): void {
        this.typed = value;
        this.confirmedChange.emit(this.isConfirmed());
    }

    isConfirmed(): boolean {
        return !!this.typed && this.normalize(this.typed) === this.normalize(this.confirmWord);
    }

    // Ignora mayúsculas, espacios y tildes (FR: DÉPUBLIER).
    private normalize(value: string): string {
        return (value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, '').toUpperCase();
    }
}
